// Title-cases a raw strategy_type_name (e.g. "RELATIVE VALUE ARBITRAGE" ->
// "Relative Value Arbitrage") for display as a fallback label.
export function titleCaseStrategyName(name) {
  return name
    .toLowerCase()
    .split(" ")
    .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : word))
    .join(" ");
}

export const STRATEGY_DISPLAY_ORDER = [
  {
    key: "merger_arb",
    label: "Merger Arb",
    strategyTypes: ["MERGER ARBITRAGE", "EXPECTED MERGER ARBITRAGE"],
  },
  {
    key: "convertible_arb",
    label: "Convertible Arb",
    strategyTypes: ["CONVERTIBLE ARBITRAGE"],
  },
  {
    key: "spac",
    label: "SPAC",
    strategyTypes: ["SPAC LIQUIDATION ARBITRAGE"],
  },
  {
    key: "credit_arb",
    label: "Credit Arb",
    strategyTypes: ["CREDIT ARBITRAGE"],
  },
  {
    key: "edfi",
    label: "EDFI",
    strategyTypes: [
      "EVENT DRIVEN FIXED INCOME",
      "YIELD TO MATURITY",
      "EXPECTED CALL",
      "REDEMPTION/MATURITY/CALL/PUT",
    ],
  },
  {
    key: "stat_arb",
    label: "Stat Arb",
    strategyTypes: ["STAT ARBITRAGE"],
  },
];
